import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends DataService {

  private baseURI = this.apiUri + '/organization/';

  constructor(http: HttpClient) {
    super(http);
  }

  getOrganizationsByAgencyMasterId(agencyMasterId): Observable<any> {
    this.setUri(this.baseURI);
    let params: HttpParams = new HttpParams();
    params = params.set('agencyMasterId', '' + agencyMasterId);
    return this.get({params});
  }
}
